module.exports = __webpack_public_path__ + "static/media/mtn25.0ea962b4.geojson";